import styled from 'styled-components';
import { TooltipPosition } from './types';

interface PositionProps {
  position: TooltipPosition;
}

export const $TooltipContainer = styled.div<PositionProps>`
  position: absolute;
  z-index: 1000;
  ${({ position }) => {
    switch (position) {
      case 'top':
        return `
          bottom: 100%;
          left: 50%;
          transform: translateX(-50%);
          margin-bottom: 12px;
        `;
      case 'bottom':
        return `
          top: 100%;
          left: 50%;
          transform: translateX(-50%);
          margin-top: 12px;
        `;
      case 'left':
        return `
          right: 100%;
          top: 50%;
          transform: translateY(-50%);
          margin-right: 12px;
        `;
      case 'right':
        return `
          left: 100%;
          top: 50%;
          transform: translateY(-50%);
          margin-left: 12px;
        `;
      default:
        return '';
    }
  }}
`;

export const $TooltipArrow = styled.div<PositionProps>`
  position: absolute;
  width: 0;
  height: 0;
  ${({ position }) => {
    switch (position) {
      case 'top':
        return `
          top: 100%;
          left: 50%;
          transform: translateX(-50%);
          border-left: 8px solid transparent;
          border-right: 8px solid transparent;
          border-top: 8px solid #1C2024;
        `;
      case 'bottom':
        return `
          bottom: 100%;
          left: 50%;
          transform: translateX(-50%);
          border-left: 8px solid transparent;
          border-right: 8px solid transparent;
          border-bottom: 8px solid #1C2024;
        `;
      case 'left':
        return `
          left: 100%;
          top: 50%;
          transform: translateY(-50%);
          border-top: 8px solid transparent;
          border-bottom: 8px solid transparent;
          border-left: 8px solid #1C2024;
        `;
      case 'right':
        return `
          right: 100%;
          top: 50%;
          transform: translateY(-50%);
          border-top: 8px solid transparent;
          border-bottom: 8px solid transparent;
          border-right: 8px solid #1C2024;
        `;
      default:
        return '';
    }
  }}
`;

export const $TooltipContent = styled.div`
  background: #1c2024;
  color: white;
  padding: 12px;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  min-width: 240px;
  max-width: 280px;
`;

export const $TooltipHeader = styled.div`
  margin-bottom: 6px;
`;

export const $TooltipStep = styled.div`
  font-size: 11px;
  font-weight: 500;
  color: #a0aec0;
  margin-bottom: 3px;
`;

export const $TooltipTitle = styled.h4`
  font-size: 14px;
  font-weight: 600;
  margin: 0;
  color: white;
`;

export const $TooltipDescription = styled.p`
  font-size: 13px;
  line-height: 1.3;
  margin: 0 0 12px 0;
  color: #e2e8f0;
`;

export const $TooltipActions = styled.div`
  display: flex;
  gap: 6px;
  justify-content: flex-end;
`;

export const $SkipButton = styled.button`
  background: transparent;
  border: 1px solid #4a5568;
  color: #a0aec0;
  padding: 4px 10px;
  border-radius: 4px;
  font-size: 12px;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: #4a5568;
    color: white;
  }
`;

export const $NextButton = styled.button`
  background: #0080ff;
  border: none;
  color: white;
  padding: 4px 12px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: #0066cc;
  }
`; 